import { Link } from "react-router-dom";
import type { MediaItem } from "@/types";

interface MediaCardProps {
  item: MediaItem;
  showType?: boolean;
}

export default function MediaCard({ item, showType = true }: MediaCardProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition-all duration-300 hover:border-primary-200 hover:bg-background-100/60"
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden bg-background-200">
        <img
          src={item.cover}
          alt={`${item.title} 封面`}
          title={`${item.title} 电影电视剧海报`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 flex items-center gap-1 rounded-md bg-accent-500 px-2 py-1 text-xs font-semibold text-background-50">
          <i className="ri-star-fill text-xs" />
          {item.rating.toFixed(1)}
        </span>
        {showType && (
          <span className="absolute right-2 top-2 rounded-md bg-primary-900/80 px-2 py-1 text-xs font-medium text-background-50">
            {item.type === "movie" ? "电影" : "剧集"}
          </span>
        )}
      </div>

      <div className="flex flex-1 flex-col p-3 md:p-4">
        <h3 className="line-clamp-1 font-heading text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-700 md:text-base">
          {item.title}
        </h3>
        <div className="mt-2 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-500">
          <span className="whitespace-nowrap">{item.year}</span>
          <span className="whitespace-nowrap">{item.region}</span>
        </div>
        <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-600">
          {item.summary}
        </p>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {item.genres.slice(0, 3).map((genre) => (
            <span
              key={genre}
              className="rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900"
            >
              {genre}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}